import React from 'react';
import stand from './../assets/img/buttons-img/stand.png'

import { sumConfig } from '../utils/utils';

//stand mini
import { slider } from '../utils/img';
//simk mini
import {modelSinks} from '../utils/img';


export default class Options extends React.Component {
    constructor(props) {
        super(props);
        this.optionsRef = React.createRef()
    }

    componentDidMount() {
        // timeline - блок с горизонтальным скроллом
        this.optionsRef.current.onmousedown = () => {
            let pageX = 0;
        
            document.onmousemove = e => {
            if (pageX !== 0) {
                this.optionsRef.current.scrollLeft = this.optionsRef.current.scrollLeft + (pageX - e.pageX);
            }
            pageX = e.pageX;
            };
        
            // заканчиваем выполнение событий
            this.optionsRef.current.onmouseup = () => {
            document.onmousemove = null;
            this.optionsRef.current.onmouseup = null;
            };
        
            // отменяем браузерный drag
            this.optionsRef.current.ondragstart = () => {
            return false;
            };
        };
    }
    render() {
        const configArray = [];
        const config = this.props.config;
        let sum = sumConfig(config);
        for(let key in config) {
            if(config[key] !== false) {
                if(key === 'mirror' && config[key].mirror.height === 888)  {
                    config[key].diameter = config[key].mirror.width
                }
                config[key].key = key;
                configArray.push(config[key])
            }
        }

        configArray.forEach(item => {
            item.imgimg = this.props.renderConfig?.[item.key === 'stand' ? 'standMaterial' : item.key];

        })

        return (
            <>
                <ul className='options' ref={this.optionsRef}>
                {configArray.map((config, i) => {
                    return (
                    <li key={i} className='options__item'>
                        <button className="button button--w-circle">
                            {/* <div className="button__img">
                                <img src={this.props.renderConfig?.[config.key === 'stand' ? 'standMaterial' : config.key] ? this.props.renderConfig[config.key === 'stand' ? 'standMaterial' : config.key] : ''} alt={config.key}/>
                            </div> */}
                            
                            <div className="button__content">
                                <span>{config.key === 'stand' ? 'Тумба' : config.key === 'sink' ? 'Раковина' : config.key === 'tabletop' ? 'Столешница' : config.key === 'mirror' ? 'Зеркало' : ''} {config.key !== 'tabletop' ? config.name : config.type === 'kg_type_A' || config.type === 'kg_type_B' ? 'Керамогранит' : 'Solid Surface'}</span>
                                {
                                    window.innerWidth > 1200 ?
                                    <>
                                        <div className='options__info'>
                                        <span>Глубина: {config.key === 'stand' ? `${config.stand.depth} мм` : config.key === 'sink' ? `${config.sink.countertop_depth} мм` : config.key === 'mirror' ? `${config.mirror.depth} мм`: config.key === 'tabletop' ? `${config.depth} мм` : config.key === 'cabinet' ? `${config.cabinet.depth} мм`: ''} </span> 
                                            {

                                                config.key === 'mirror' ?
                                                    config.mirror.height === 888 ?
                                                    <span>Диаметр: {config.key === 'stand' ? `${config.stand.depth} мм` : config.key === 'sink' ? `${config.sink.countertop_depth} мм` : config.key === 'mirror' ? `${config.mirror.width} мм`: config.key === 'tabletop' ? `${config.depth} мм` : config.key === 'cabinet' ? `${config.cabinet.depth} мм`: ''} </span> 
                                                    :
                                                    <> 
                                                        <span>Ширина: {config.key === 'stand' ? `${config.stand.width} мм` : config.key === 'sink' ? `${config.sink.countertop_width} мм` : config.key === 'mirror' ? `${config.mirror.width} мм`: config.key === 'tabletop' ? `${config.tabletop.width} мм` : config.key === 'cabinet' ? `${config.cabinet.width} мм`: ''} </span>
                                                        <span>Высота: {config.key === 'stand' ? `${config.stand.height} мм` : config.key === 'sink' ? `${config.type === 'mm100' ? '100 мм' : '12 мм'}` : config.key === 'mirror' ? `${config.mirror.height} мм`: config.key === 'tabletop' ? `${config.height} мм` : config.key === 'cabinet' ? `${config.cabinet.height} мм`: ''} </span>
                                                    </>
                                                :
                                                <> 
                                                    
                                                    <span>Ширина: {config.key === 'stand' ? `${config.stand.width} мм` : config.key === 'sink' ? `${config.sink.countertop_width} мм` : config.key === 'mirror' ? `${config.mirror.width} мм`: config.key === 'tabletop' ? `${config.tabletop.width} мм` : config.key === 'cabinet' ? `${config.cabinet.width} мм`: ''} </span>
                                                    <span>Высота: {config.key === 'stand' ? `${config.stand.height} мм` : config.key === 'sink' ? `${config.type === 'mm100' ? '100 мм' : '12 мм'}` : config.key === 'mirror' ? `${config.mirror.height} мм`: config.key === 'tabletop' ? `${config.height} мм` : config.key === 'cabinet' ? `${config.cabinet.height} мм`: ''} </span>
                                                </>
                                            }
                                            
                                        </div>
                                        
                                    </>
                                    :
                                    <></>
                                
                                }
                                <span>Цена: {Number(config.price) + (config.key === 'tabletop' && config.countCup === 2 ? 3530 : 0) + Number(config.flap ? config.flap.price ? config.flap.price * (config.position === 'D' ? 2 : 1) : 0 : 0)} ₽</span>
                            </div>
                        </button>
                    </li>)
                })
                }
                    
                </ul>
                {
                    window.innerWidth < 1200 ?
                        <button onClick={() => {
                            this.props.setStatusWindow({
                                value: true,
                                type: 'form'
                            })
                        }} 
                        className="header__busket-button button"
                        >
                            <div className="button__content" >
                                <span>Итог: {sum} ₽</span>
                                <span>Оформление заказа</span>
                            </div>
                        </button>
                    :
                    <></>
                }
                
            </>
            
        );
    }
}